import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'
import { QUERY_KEY_DIRECTOR } from './useApiGetDirectorMessage'
import { GLOBAL_ERROR } from '../../constants/translations/error'
import { useTranslation } from 'react-i18next'

export const useApiPutDirectorMessage = (storeId: number) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const directorWordEndpoint = `/dir_message/${storeId}`
  return useMutation({
    mutationFn: (newMessage: string) =>
      axios
        .put(directorWordEndpoint, newMessage, {
          headers: { 'content-type': 'text/plain' }
        })
        .then(response => response.data),
    onSuccess: () => {
      toast.info(t('pilotable.data_saved'))
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_DIRECTOR, directorWordEndpoint] })
    },
    onError: () => {
      toast.error(t(GLOBAL_ERROR))
    }
  })
}
